// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Roboto_Mono_477670', '__Roboto_Mono_Fallback_477670'","fontStyle":"normal"},"className":"__className_477670","variable":"__variable_477670"};